import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateTimeAdapterService } from '@p2p/i18n';
import { DateTime } from 'luxon';

const mapDates = {
    date: {
        short: {
            noSeconds: DateTime.DATE_SHORT,
            withSeconds: DateTime.DATE_SHORT
        },
        med: {
            noSeconds: DateTime.DATE_MED,
            withSeconds: DateTime.DATE_MED
        }
    },
    date_time: {
        short: {
            noSeconds: DateTime.DATETIME_SHORT,
            withSeconds: DateTime.DATETIME_SHORT
        },
        med: {
            noSeconds: DateTime.DATETIME_MED,
            withSeconds: DateTime.DATETIME_MED
        }
    }
};

@Pipe({
    name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
    private readonly dateTime = inject(DateTimeAdapterService);

    transform(
        value: string,
        type: 'date' | 'date_time' = 'date',
        length: 'short' | 'med' = 'short',
        withSeconds = false
    ): string {
        return this.dateTime
            .fromISO(value)
            .toLocaleString(mapDates[type][length][withSeconds ? 'withSeconds' : 'noSeconds']);
    }
}
